<template>
	<el-container>
		<el-header style="padding: 0px; height: 70px"> <navTopBar /></el-header>
		<el-main style="padding: 0px">
			<div class="page">
				<slot></slot>
			</div>
		</el-main>
	</el-container>
</template>

<script>
import navTopBar from "../components/navTopBar.vue";
export default {
	components: {
		navTopBar,
	},
};
</script>

<style scoped></style>
